import React, {useEffect, useState} from 'react';
import { useFetch } from "../../../../components/common/FetchProvider";
import {columnsDataNature} from "../variables/columnsData";
import NatureModal from "./NatureModal";
import CommonTable from "./CommonTable";

function NatureTable() {
  const fetchWrapper = useFetch();
  const [loading, setLoading] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [error, setError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [natureData, setNatureData] = useState(null);


  useEffect(() => {
    fetchData();
  }, []);

  const handleLinkClick = () => {
    setShowModal(true);
  };

  const refreshData = () => {
    reload();
  }

  const reload = () => {
    setNatureData(null);
    setApiData([]);
    fetchData();
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      let apiUrl = `${process.env.REACT_APP_API_URL}/v1/configuration/nature`;

      const userToken = localStorage.getItem("token");
      const response = await fetchWrapper(apiUrl, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });
      setLoading(false);
      if (response.ok) {
        const responseData = await response.json();
        if (responseData.data && responseData.data.length > 0) {
          setApiData(responseData.data);
        } else {
          setError(true);
        }
      } else {
        setError(true);
        console.error('Error fetching API data:', response.status);
      }
    } catch (error) {
      setLoading(false);
      setError(true);
      console.error('Error fetching API data:', error);
    }
  };

  const mappedApiData = apiData.map((item) => ({
    id: item.id,
    name: item.name,
    category: item.category,
    code: item.code,
    type: item.type,
    action: "Action"
  }));

  const handleActionClick = (rowData) => {
    let data = apiData.find((item) => item.id === rowData.id);
    setNatureData(data);
    handleLinkClick();
  };

  return (
      <div className="10">
        <header className="relative flex items-center justify-between">
          <div className="text-xl font-bold text-navy-700 dark:text-white">
            Natureza
          </div>
          {/* Links with Separator */}
          <div className="flex justify-center items-center font-bold text-brand-600">
            <div>
              <button onClick={handleLinkClick}>Cadastrar</button>
              {/* Conditional rendering of modal */}
              {showModal && (
                  <NatureModal
                      showModal={showModal}
                      setModalState={setShowModal}
                      refreshData={refreshData}
                      natureData={natureData}
                      setNatureData={setNatureData}
                  />
              )}
            </div>
          </div>
        </header>

        <div className="mt-1">
          {loading ? (
              <div></div>
          ) : apiData && apiData.length > 0 ? (
              <CommonTable
                  columnsData={columnsDataNature}
                  tableData={mappedApiData}
                  onActionClick={handleActionClick}
              />
          ) : (
              <></>
          )}
        </div>

      </div>
  );
}

export default NatureTable;
